import { Map, Record, Set } from 'immutable';

import { simpleAction } from '../../common/utils/reduxUtils';

const InitialState = Record({
  dialogsOpen: Set(),
  dialogsData: Map(),
  dialogsDontShowAgain: Set(),
});
const INITIAL_STATE = InitialState();

const SET_DIALOG_OPEN = 'SET_DIALOG_OPEN';
const SET_DIALOG_DATA = 'SET_DIALOG_DATA';
const SET_DIALOG_DONT_SHOW_AGAIN = 'SET_DIALOG_DONT_SHOW_AGAIN';
const CLEAR_DIALOGS = 'CLEAR_DIALOGS';

export function dialogsReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_DIALOG_OPEN:
      // OPEN
      if (action.open) {
        if (state.dialogsDontShowAgain.has(action.spec)) {
          return state;
        }

        return state
          .update('dialogsOpen', dialogsOpen => dialogsOpen.add(action.spec))
          .update('dialogsData', dialogsData =>
            dialogsData.set(action.spec, action.data)
          );
      }
      // CLOSE
      return state
        .update('dialogsOpen', dialogsOpen => dialogsOpen.remove(action.spec))
        .update('dialogsData', dialogsData => dialogsData.delete(action.spec))
        .update('dialogsDontShowAgain', dialogsDontShowAgain =>
          action.dontShowAgain
            ? dialogsDontShowAgain.add(action.spec)
            : dialogsDontShowAgain
        );

    case SET_DIALOG_DATA:
      return state.update('dialogsData', dialogsData =>
        dialogsData.set(action.spec, action.data)
      );
    case SET_DIALOG_DONT_SHOW_AGAIN:
      return state.update('dialogsDontShowAgain', dialogsDontShowAgain =>
        action.value
          ? dialogsDontShowAgain.add(action.spec)
          : dialogsDontShowAgain.remove(action.spec)
      );
    case CLEAR_DIALOGS:
      return state.clear();
    default:
      return state;
  }
}

export const getIsDialogOpen = (id, spec) => state =>
  state.dialogs.dialogsOpen.has(Map({ id, ...spec }));
export const getDialogData = (id, spec) => state =>
  state.dialogs.dialogsData.get(Map({ id, ...spec }));
export const getIsDialogDontShowAgain = (id, spec) => state =>
  state.dialogs.dialogsDontShowAgain.has(Map({ id, ...spec }));

export function openDialog({ id, spec, data }) {
  return {
    type: SET_DIALOG_OPEN,
    open: true,
    spec: Map({ id, ...spec }),
    data,
  };
}

export function closeDialog({ id, spec, dontShowAgain }) {
  return {
    type: SET_DIALOG_OPEN,
    open: false,
    spec: Map({ id, ...spec }),
    dontShowAgain: dontShowAgain === true,
  };
}

export function setDialogData({ id, spec, data }) {
  return {
    type: SET_DIALOG_DATA,
    spec: Map({ id, ...spec }),
    data,
  };
}

export function setDialogDontShowAgain({ id, spec, value }) {
  return {
    type: SET_DIALOG_DONT_SHOW_AGAIN,
    spec: Map({ id, ...spec }),
    value,
  };
}

export const clearDialogs = simpleAction(CLEAR_DIALOGS);
